import React from 'react'
import { Button } from 'antd'
import './index.less'

const AboutComponent = function () {
  const urls = [
    'nuiii.com',
    'yrooo.com',
    '0ci.cc'
  ]

  return (
    <div class="page-about">
      {urls.map(url => <a href={`http://${url}`} target="_blank">{url}</a>)}
    </div>
  )
}
export default AboutComponent